import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import React from 'react';
import {Line} from 'react-chartjs-2';

ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend,
                 CategoryScale);

const PitchPlot = ({
  initialData = {},
  recordedData = {},
  highlightedTone = null // Which tone is highlighted
}) => {
  // Convert initial and recorded data into the format required by Chart.js
  const datasets = [];

  // Extract and format data for each tone
  for (const tone in initialData) {
    if (initialData[tone] && recordedData[tone]) {
      const initialPitchData = initialData[tone].pitch.map((p, i) => ({ x: initialData[tone].time[i] || 0, y: p }));
      const recordedPitchData = recordedData[tone].pitch.map((p, i) => ({ x: recordedData[tone].time[i] || 0, y: p }));

      datasets.push(
        {
          label: `Initial Pitch Contour (Tone ${tone})`,
          data: initialPitchData,
          fill: false,
          backgroundColor: highlightedTone === parseInt(tone) ? 'rgba(255,99,132,1)' : 'rgba(255,99,132,0.2)',
          borderColor: highlightedTone === parseInt(tone) ? 'rgba(255,99,132,1)' : 'rgba(255,99,132,0.2)',
          borderWidth: highlightedTone === parseInt(tone) ? 3 : 3,
            tension: 0.3, // Smoothing factor (between 0 and 1)
        },
        {
          label: `Recorded Pitch Contour (Tone ${tone})`,
          data: recordedPitchData,
          fill: false,
          backgroundColor: highlightedTone === parseInt(tone) ? 'rgba(153,102,255,1)' : 'rgba(153,102,255,0.2)',
          borderColor: highlightedTone === parseInt(tone) ? 'rgba(153,102,255,1)' : 'rgba(153,102,255,0.2)',
          borderWidth: highlightedTone === parseInt(tone) ? 3 : 3,
            tension: 0.3, // Smoothing factor (between 0 and 1)
        }
      );
    }
  }

  const data = {
    datasets: datasets,
  };

  const options = {
    scales: {
      x: {
        type: 'linear',
        title: {
          display: true,
          text: 'Time (s)',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Pitch (Hz)',
        },
      },
    },
    elements: {
        point: {
            radius: 0,            // Removes the dots on the line
            hoverRadius: 0        // Disables hover effect for the dots
        }
    },
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `Pitch: ${tooltipItem.raw.y.toFixed(2)}`;
          },
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default PitchPlot;
